type CookieOptions = {
  path?: string
  expires?: Date
  secure?: boolean
  sameSite?: "strict" | "lax" | "none"
}

export function getCookie(name: string) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  return parts.length === 2 ? (parts.pop()?.split(";").shift() ?? null) : null
}

export function setCookie(name: string, value: string, options: CookieOptions) {
  let cookieString = `${name}=${value}; path=/`
  if (options.expires) {
    cookieString += `; expires=${options.expires.toUTCString()}`
  }
  if (options.secure) {
    cookieString += "; secure"
  }
  if (options.sameSite) {
    cookieString += `; samesite=${options.sameSite}`
  }
  document.cookie = cookieString
}
